<template>
  <div id="modal__OnRentMaint">
    <div id="apply-cm-form-container">
      <div class="company-search">
        <div class="company-input">
          <BFormInput v-model="unitNumber" required size="sm" class="cm-input"
            placeholder="Enter Unit Number"
            @keypress.enter="findUnitForMaint(unitNumber)"></BFormInput>
        </div>
        <BButton variant="primary" class="company-search-btn" 
        @click="findUnitForMaint(unitNumber)" 
        >Search</BButton>
      </div>
      <div v-if="searchComplete">
				<div class="service-maint-container">
          <div class="company-info">Truck found: <b>{{ unitInfo.VinNumber }}</b></div>
          <div class="company-info">Unit Info: <b>{{ unitInfo.TruckYear }} - {{ unitInfo.TruckModel }}</b></div>
          <div class="company-info">Current Status: <b>{{ unitInfo.TruckStatusDescription }}</b></div>
          <div class="company-info" v-if="unitInfo.TruckStatusDescription !== 'On Rent'">Current Sub Status: <b>{{ unitInfo.DashboardSubStatus }}</b></div>
          <div class="company-info">Last Rental: <b>{{ unitInfo.Company }}</b></div>
          <div class="company-info" v-if="unitInfo.TruckStatusDescription !== 'On Rent'">
            <BDropdown class="status-change-add" menu-class="sub-stat-menu" auto-close="outside" no-fade :text="tempSubStatus ? tempSubStatus.length > 20 ? tempSubStatus.slice(0, 20) + '...' : 
                tempSubStatus : 'Select Sub Status'">
              <!-- Search box -->
              <div class="px-2 py-1" @click.stop @mousedown.stop>
                <BFormInput
                  v-model="subStatusSearch"
                  size="sm"
                  placeholder="Search Sub Status's..."
                />
              </div>
              <BDropdownDivider />
              <BDropdownItem v-for="(status) in filteredSubStatuses" :key="status.DashboardSubStatus" 
                @click="setTempSubStatus(status.DashboardSubStatus)" 
                :class="tempSubStatus ? 'selected-status' : ''">
                {{ status.DashboardSubStatus }}
              </BDropdownItem>
            </BDropdown>
          </div>
          <div class="company-info">
            <BRow>
              <BCol cols="auto">
                <div class="service-maint-text"><span class="red">*</span>Maintenance Date: 
                <datepicker
                  class="datepicker service-maint-datepicker"
                  model-type="yyyy-MM-dd"
                  name="maintDate"
                  week-start="0"
                  :bootstrap-styling="true"
                  v-model="maintenanceDate"
                  :format="format"
                  :enable-time-picker="false"
                  :timezone="{ timezone: 'UTC', exactMatch: true }"
                  :dark="getUserInfo.UserTheme == 'Dark' ? true : false"
                  ignore-time-validation
                  auto-apply
                  vertical
                  arrow-navigation
                  required
                ></datepicker></div>
              </BCol>
              <BCol cols="auto">
                <div class="service-maint-text">Follow Up Date: 
                <datepicker
                  class="datepicker service-maint-datepicker"
                  model-type="yyyy-MM-dd"
                  name="followUpDate"
                  week-start="0"
                  :bootstrap-styling="true"
                  v-model="followUpDate"
                  :format="format"
                  :enable-time-picker="false"
                  :timezone="{ timezone: 'UTC', exactMatch: true }"
                  :dark="getUserInfo.UserTheme == 'Dark' ? true : false"
                  ignore-time-validation
                  auto-apply
                  vertical
                  arrow-navigation
                  required
                ></datepicker></div>
              </BCol>
            </BRow>
          </div>
          <div class="company-info">Dealership Info:
            <div class="dealer-info">
              <BInput v-model="dealerName" placeholder="Dealer Name"></BInput>
              <BInput v-model="dealerPhone" type="tel" v-mask="validatePhone" placeholder="Phone Number"></BInput>
              <BInput v-model="dealerEmail" placeholder="Email Address"></BInput>
              <BInput v-model="dealerAdvisor" placeholder="Service Advisor"></BInput>
            </div>
          </div>
          <div class="company-info">Client Info:
            <div class="dealer-info">
              <BInput v-model="clientName" placeholder="Client Name"></BInput>
              <BInput v-model="clientPhone" type="tel" v-mask="validatePhone" placeholder="Phone Number"></BInput>
              <BInput v-model="clientEmail" placeholder="Email Address"></BInput>
            </div>
          </div>
          <div class="company-info">Issue:
            <div class="dealer-info">
              <BInput v-model="serviceIssue" placeholder="What's wrong?"></BInput>
            </div>
          </div>
          <div class="company-info">
            <label style="display:block; margin-bottom:4px;">Service Notes:</label>
            <textarea v-model="serviceNotes" class="cm-textarea"></textarea>
          </div>
          <div class="company-info">
            <BFormRadioGroup
              id="warranty-radio"
              v-model="warranty"
              name="Warranty"
            >
              <BFormRadio value="true">Warranty</BFormRadio>
              <BFormRadio value="false">Non Warranty</BFormRadio>
              <BFormRadioGroup
                id="warranty-pay-radio"
                v-model="warrantyPay"
                name="WarrantyPay"
                class="warranty-pay"
                v-if="warranty == 'false'"
              >
                <BFormRadio value="barco">Barco Paying</BFormRadio>
                <BFormRadio value="customer">Customer Paying</BFormRadio>
                <BInput v-if="warrantyPay == 'customer'" v-model="warrantyApprovedBy" class="dealer-info warranty-pay" placeholder="Who approved this?"></BInput>
                <datepicker
                  v-if="warrantyPay == 'customer'"
                  class="datepicker warranty-pay-datepicker"
                  model-type="yyyy-MM-dd"
                  name="approvedDate"
                  week-start="0"
                  :bootstrap-styling="true"
                  v-model="warrantyApprovedOn"
                  :format="format"
                  :enable-time-picker="false"
                  :timezone="{ timezone: 'UTC', exactMatch: true }"
                  :dark="getUserInfo.UserTheme == 'Dark' ? true : false"
                  ignore-time-validation
                  auto-apply
                  vertical
                  arrow-navigation
                  required
                ></datepicker>
                <BInput v-model="estimatedCost" class="dealer-info warranty-pay" placeholder="Estimated Cost"></BInput>
                <!-- <BInput v-model="finalCost" class="dealer-info warranty-pay" placeholder="Final Cost"></BInput> -->
              </BFormRadioGroup>
            </BFormRadioGroup>
          </div>
			</div>
      </div>
      <div class="apply-cm__footer">
			<div v-if="successMessage != ''">
				<p class="success">{{ successMessage }}</p>
			</div>
			<div v-if="errorMessage != ''">
				<p class="error">{{ errorMessage }}</p>
			</div>
        <div v-if="searchComplete">
          <BButton
            v-if="!spinners.submitting"
            id="apply-btn"
            variant="outline-warning"
            :disabled="error"
            @click="putInMaintenance()"
            >Put In Maintenance</BButton
          >
          <div v-else id="apply-btn">
            <BSpinner id="b-spinner--apply-btn__spinner"></BSpinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/constants';
import { mapActions, mapGetters } from 'vuex';
import { currencyFilter } from '../../utils/helpers/currencyFilter';

export default {
  name: 'serviceMaintenance',
  components: {},
  props: ['subStatusList'],
  data() {
    return {
      spinners: {
        submitting: false,
			},
      unitNumber: '',
      unitInfo: {},
      // default to today's date
      maintenanceDate: new Date().toISOString().split('T')[0],
      followUpDate: null,
      format: 'MM/dd/yyyy',
      successMessage: '',
      errorMessage: '',
      searchComplete: false,
      error: false,
      dealerName: '',
      dealerAdvisor: '',
      dealerPhone: '',
      dealerEmail: '',
      clientName: '',
      clientPhone: '',
      clientEmail: '',
      serviceIssue: '',
      serviceNotes: '',
      warranty: '',
      warrantyPay: '',
      warrantyApprovedBy: '',
      warrantyApprovedOn: new Date().toISOString().split('T')[0],
      estimatedCost: '',
      tempSubStatus: '',
      subStatusSearch: '',
    };
  },
  computed: {
    ...mapGetters(['getModalData', 'getUserInfo']),
    filteredSubStatuses() {
      if (!this.subStatusSearch) {
        return this.subStatusList;
      }

      const search = this.subStatusSearch.toLowerCase();
      return this.subStatusList.filter(s =>
        s.DashboardSubStatus.toLowerCase().includes(search)
      );
    },
    validatePhone() {
      if (this.dealerPhone && (this.dealerPhone.substring(0, 1) == '+' || this.dealerPhone.substring(0, 1) == '1')) {
        return ['+# (###) ###-####', '+## (###) ###-####'];
      } else {
        return '(###) ###-####';
      }
    },
  },
  methods: {
    ...mapActions(['closeModal']),
    setTempSubStatus(stat) {
      this.tempSubStatus = stat;
    },
    findUnitForMaint(unit) {
      if (unit != '') {
        this.searchComplete = false;
        this.errorMessage = '';
        axios
          .get(`${constants.BASE_URL}/api/service/unit-for-maintenance/${unit}`, {
            headers: {
              Authorization: localStorage.getItem('token'),
            },
          })
          .then(result => {
            if (result.data.length == 0) {
              this.searchComplete = false;
              this.errorMessage = "Error, Unit not found/available."
            } else {
              this.searchComplete = true;
              this.unitInfo = result.data[0];
            }
          })
          .catch(err => {
            console.log('err: ', err)
            this.searchComplete = false;
            this.errorMessage = "Error, Unit not found/available."
          });
      }
    },
    putInMaintenance() {
      this.spinners.submitting = true;
      if (this.unitInfo.TruckStatusDescription !== 'On Rent' && this.tempSubStatus == '') {
        this.spinners.submitting = false;
        this.errorMessage = 'Sub Status Required';
        return;
      } else if (!this.maintenanceDate || this.maintenanceDate == '') {
        this.spinners.submitting = false;
        this.errorMessage = 'Maintenance Date Required';
        return;
      }

      let unit = this.unitNumber;
      axios.post(`${constants.BASE_URL}/api/service/unit-add-maintenance`, {
        UnitNumber: unit,
        TagHistoryID: this.unitInfo.TagHistoryID,
        SubStatus: this.tempSubStatus,
        MaintenanceDate: this.maintenanceDate,
        FollowUpDate: this.followUpDate,
        DealerName: this.dealerName,
        ServiceAdvisor: this.dealerAdvisor,
        DealerPhone: this.dealerPhone,
        DealerEmail: this.dealerEmail,
        ClientName: this.clientName,
        ClientPhone: this.clientPhone,
        ClientEmail: this.clientEmail,
        ServiceIssue: this.serviceIssue,
        ServiceNotes: this.serviceNotes,
        Warranty: this.warranty == 'true' ? 1 : this.warrantyPay == 'barco' ? 2 : this.warrantyPay == 'customer' ? 3 : 0,
        WarrantyApprovedBy: this.warrantyApprovedBy,
        WarrantyApprovedOn: this.warranty == 'false' && this.warrantyPay == 'customer' ? this.warrantyApprovedOn : null,
        EstimatedCost: this.estimatedCost,
        OnOff: this.unitInfo.TruckStatusDescription == 'On Rent' ? 'On' : 'Off'
        // FinalCost: this.finalCost,
      }, {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      })
      .then(result => {
        this.spinners.submitting = false;
        this.successMessage = "Successfully put unit in maintenance.";
        this.errorMessage = '';
        this.closeModal();
      })
      .catch(err => {
        this.spinners.submitting = false;
        this.errorMessage = "Error occurred while putting unit in maintenance.";
        this.successMessage = '';
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index';

#modal__OnRentMaint {
  min-height: 100%;
  min-width: 100%;
}

.modal-lg {
	max-width: 1000px;
}

#apply-cm__title {
  margin: 10px 0;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
}

#apply-cm-form-container {
  width: 90%;
  margin: 0 auto;
}

.apply-cm__footer {
  height: 14vh;
  width: 100%;
  @include F($d: column);
  textarea {
    outline: none;
    border: 1px solid #dee2e6;
    border-radius: 3px;
    font-size: 0.9rem;
    color: var(--lightened-text-color);
    font-weight: 500;
    padding: 5px 10px;
    resize: none;
    width: 100%;
    height: 90%;
    margin-bottom: 10px;
  }
  #apply-btn {
    margin: 5px 0 10px auto;
  }

  #b-spinner--apply-btn__spinner {
    color: #5aaaff;
  }
}

.cm-input {
  max-width: 200px;
	height: calc(1.5em + .75em + 10px);
}

.cm-textarea {
	margin-bottom: 10px;
}

p {
	font-size: 1rem;
}

.service-maint-container {
  @include F(center, flex-start, column);
  flex-wrap: wrap;
  width: 101%;
  margin: 10px -15px;
  b {
    margin: 0 5px 0 5px;
  }
  p {
    margin: 0px;
  }
  input {
    background: none;
		border: 1px solid lightgray;
		border-radius: 5px;
		margin-right: 5px;
		padding: 5px;
    outline: none;
  }
}

.service-maint-div {
	@include F(center, flex-start, column);
	width: 100%;
}

.cm-vin-row {
  @include F(flex-start, center);
  flex-wrap: wrap;
  background: var(--edit-bg-color);
  margin: 5px 0;
  padding: 5px;
  width: 100%;
  b {
    font-weight: 700;
  }
  input {
    font-size: 0.8rem;
    padding: 5px;
  }
  .datepicker {
    margin: 5px;
    min-width: 150px;
  }
}

.edit__plus {
  color: green;
  cursor: pointer;
  margin: 0 5px 0;
  font-size: 0.8rem;
}

.edit__minus {
  color: firebrick;
  cursor: pointer;
  margin: 0 5px;
  font-size: 0.8rem;
}

.edit__btns-container {
  margin: 10px 0 0;
  padding: 0 10px 0 0;
  @include F($j: space-between);
  width: 100%;
}

#edit__addVin {
  cursor: pointer;
  @include F();
  p {
    font-weight: 600;
  }
}

.invoice-note {
	max-width: 200px;
  min-height: 31px;
  margin: 5px;
	background: var(--edit-bg-color);
	border: 1px solid lightgray;
}

.success {
	color: green;
}

.error {
	color: red;
}

.company-search {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}

.company-search-btn {
  margin-left: 20px;
  max-height: 50px;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 40px;
}

.company-info {
  margin-left: 50px;
  margin-top: 10px;
  width: 100%;
}

.service-maint-text {
  // margin-left: 200px;
  display: block;
}

.service-maint-datepicker {
  margin-left: 20px;
}

.warranty-pay-datepicker {
  margin-left: 25px;
  margin-top: 10px;
}

.datepicker {
  max-width: 175px;
}

.input-width {
  max-width: 125px;
}

.override-container {
  cursor: pointer;
  p {
    font-weight: 500;
  }
}

.no-button {
  margin-left: 10px;
  margin-right: 10px;
}

.override-div {
  display: flex;
}

.override-input {
  height: 40px;
}

.company-apply-btn {
  height: 40px;
  margin-left: 10px;
}

.override-btn {
  margin-right: 10px;
}

.dealer-info {
  margin-left: 20px;
  max-width: 300px;
  input {
    margin-bottom: 5px;
  }
}

.cm-textarea {
  width: 100%;
  min-height: 100px;
  max-width: 600px;
  margin-left: 20px;
}

.warranty-pay {
  margin-top: 10px;
  margin-left: 25px;
}

.red {
  color: red;
  font-weight: 600;
}

.sub-stat-dropdown {
  z-index: 10;
}
</style>

<style lang="scss">
.sub-stat-menu {
  z-index: 1200 !important;
}
</style>
